
import { FallacyReference } from "@/components/FallacyReference";
import { Button } from "@/components/ui/button";
import { BookOpen, Search } from "lucide-react";
import { Link } from "react-router-dom";

const FallacyGuide = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="text-center">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="p-3 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl shadow-lg">
                <BookOpen className="w-8 h-8 text-white" />
              </div>
              <h1 className="text-4xl font-bold bg-gradient-to-r from-indigo-800 to-purple-800 bg-clip-text text-transparent">
                Fallacy Reference Guide
              </h1>
            </div>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
              Master logical reasoning with our comprehensive guide to logical fallacies, complete with examples and explanations.
            </p>
            
            <div className="mt-6">
              <Link to="/analyze">
                <Button size="lg" className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700">
                  <Search className="w-5 h-5 mr-2" />
                  Analyze Text for Fallacies
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="max-w-7xl mx-auto">
          <FallacyReference />
        </div>
      </div>
    </div>
  );
};

export default FallacyGuide;
